import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

// In-memory, per-tab cache of whole-collection reads. Shared by every page that reads
// competition data, so the big `competitions` collection is downloaded once per TTL instead
// of once per page / filter change. Concurrent callers share the same in-flight request.
const TTL = 5 * 60 * 1000; // 5 minutes
const cache = new Map(); // path -> { time, promise }

/**
 * Cached equivalent of getDocs(collection(db, ...pathSegments)).
 * Resolves to a normal QuerySnapshot (.docs, .forEach, .empty, ...).
 */
export function cachedGetDocs(...pathSegments) {
  const key = pathSegments.join('/');
  const hit = cache.get(key);
  if (hit && Date.now() - hit.time < TTL) return hit.promise;

  const promise = getDocs(collection(db, ...pathSegments));
  cache.set(key, { time: Date.now(), promise });
  promise.catch(() => cache.delete(key)); // don't cache failures
  return promise;
}

export function clearFirestoreCache() {
  cache.clear();
}
